import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { useUserSettingsSite } from "../../@hooks"


export default function UserSettingsSitesTabButton() {

    const { handleSetSitesFormData } = useUserSettingsSite()

    return <ButtonLoadingSeeker
        startIcon={<IconSeeker icon="add" />}
        onClick={handleSetSitesFormData}
    >
        Define Sites Color
    </ButtonLoadingSeeker>
}